import axios from 'axios'

let baseDomain = process.env.REACT_APP_VIMS_URL || null

if (baseDomain === null) {
  let baseAdminDomain = window.location.host.toString()
  switch (baseAdminDomain) {
    case 'admin-dev.hubswitch.com':
      baseDomain = 'https://vims-api-dev.hubswitch.com'
      break
    case 'admin-beta.hubswitch.com':
      baseDomain = 'https://vims-api-beta.hubswitch.com'
      break
    case 'admin.hubswitch.com':
      baseDomain = 'https://vims-api.hubswitch.com'
      break
    case '127.0.0.1:3000':
      baseDomain = 'http://127.0.0.1:3332'
      break
    case 'admin-yok.hubswitch.com':
      baseDomain = 'https://vims-api-beta.hubswitch.com'
      break
    case 'admin-ton.hubswitch.com':
      baseDomain = 'https://vims-api-beta.hubswitch.com'
      break
    case 'admin-an.hubswitch.com':
      baseDomain = 'https://vims-api-beta.hubswitch.com'
      break
    case 'admin-vims.hubswitch.com':
      baseDomain = 'https://vims-api-qa.hubswitch.com'
      break
    default:
      baseDomain = 'http://' + window.location.hostname + ':3332'
      break
  }
}

const apiEndpoint = baseDomain + '/v1'

// Set up Axios instance
export const apiInstance = axios.create({
  baseURL: apiEndpoint,
})

// Helper function to get VIMS token
const getVimsToken = async () => {
  const apiToken = localStorage.getItem('api_token')
  if (!apiToken) {
    throw new Error('API token not found')
  }

  const tempInstance = axios.create({
    baseURL: apiEndpoint,
    headers: {
      Authorization: `Bearer ${apiToken}`,
    },
  })

  const response = await tempInstance.get('admins/exchange')
  const vimsToken = response.data?.token
  if (vimsToken) {
    localStorage.setItem('vims_token', vimsToken)
    return vimsToken
  }
  throw new Error('Failed to get VIMS token')
}

// Paths that do not require authentication
const skipAuthPaths = ['options', 'external', 'upload/images']

// Request interceptor to ensure VIMS token exists
apiInstance.interceptors.request.use(
  async (config) => {
    // Skip authentication for specific paths
    const path = config.url.replace(apiEndpoint + '/', '')
    if (skipAuthPaths.some((p) => path.startsWith(p))) {
      return config
    }

    let vimsToken = localStorage.getItem('vims_token')

    if (!vimsToken) {
      try {
        vimsToken = await getVimsToken()
      } catch (error) {
        console.error('Failed to get VIMS token:', error)
        return Promise.reject(error)
      }
    }

    config.headers.Authorization = `Bearer ${vimsToken}`
    return config
  },
  (error) => Promise.reject(error)
)

// Response interceptor to handle token expiry
apiInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      try {
        const newToken = await getVimsToken()
        originalRequest.headers.Authorization = `Bearer ${newToken}`
        return apiInstance(originalRequest)
      } catch (refreshError) {
        return Promise.reject(refreshError)
      }
    }
    return Promise.reject(error)
  }
)

const api = {
  get: async (path, params = {}) => {
    try {
      const response = await apiInstance.get(`${apiEndpoint}/${path}`, {
        params,
      })
      return response.data
    } catch (error) {
      console.error('GET Error:', error.message)
      return null
    }
  },

  post: async (path, data) => {
    try {
      const response = await apiInstance.post(`${apiEndpoint}/${path}`, data)
      return response.data
    } catch (error) {
      console.error('POST Error:', error.message)
      return null
    }
  },

  put: async (path, data) => {
    try {
      const response = await apiInstance.put(`${apiEndpoint}/${path}`, data)
      return response.data
    } catch (error) {
      console.error('PUT Error:', error.message)
      return null
    }
  },

  delete: async (path) => {
    try {
      const response = await apiInstance.delete(`${apiEndpoint}/${path}`)
      return response.data
    } catch (error) {
      console.error('DELETE Error:', error.message)
      return null
    }
  },
}

export default api
